import React, { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface PaginationButtonProps
  extends React.AnchorHTMLAttributes<HTMLElement> {
  disabled: boolean;
  isActive?: boolean;
}

const PaginationButton = ({
  className = '',
  isActive = false,
  disabled,
  children,
  ...anchorProps
}: PropsWithChildren<PaginationButtonProps>) => (
  <a
    {...anchorProps}
    data-cy={anchorProps.id}
    role="button"
    className={twMerge(
      'hover:bg-gray-200 hover:font-bold',
      'flex items-center justify-center w-12 h-12 text-sm border-0 border-solid cursor-pointer',
      isActive && 'font-bold bg-gray-200 pointer-events-none',
      disabled
        ? 'pointer-events-none text-gray-500 bg-gray-200'
        : 'text-blue-700',
      className
    )}
  >
    {children}
  </a>
);

export default PaginationButton;
